//@ts-ignore
import React from "react"
import {createRoot} from "react-dom/client";
import {Typography} from "antd";
import App from "./App";
import "./assets/style.css";

declare global {
    interface Window {
        userprofile: any;
    }
}

fetch('config.json').then(data => data.json()).then(data => {
    window.userprofile = data.userprofile;
    createRoot(document.getElementById("root") as HTMLElement).render(
        <React.StrictMode>
            <React.Suspense fallback={
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Typography.Text>Chargement des données...</Typography.Text>
                </div>
            }>
                <App/>
            </React.Suspense>
        </React.StrictMode>
    );
})

